import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, G, Defs, ClipPath, Rect } from "react-native-svg";

import { isWeb } from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";

export default function SleepIcon(props) {
  const color = AppTheme.DEFAULT_COLOR;
  const width = props.width || 32;
  const height = props.height || 32;

  return (
    <TouchableOpacity {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip_calendar)">
          <Path
            d="M18.7762 5.83333C20.6909 5.83044 22.5645 6.38804 24.166 7.43735C22.2773 7.87133 20.5916 8.93308 19.3844 10.4491C18.1772 11.9651 17.52 13.8457 17.52 15.7837C17.52 17.7216 18.1772 19.6023 19.3844 21.1183C20.5916 22.6343 22.2773 23.696 24.166 24.13C22.8676 24.9643 21.3927 25.4846 19.8582 25.6498C18.3238 25.8149 16.772 25.6204 15.3257 25.0816C13.8795 24.5429 12.5787 23.6746 11.5263 22.5457C10.474 21.4168 9.69903 20.0583 9.26294 18.5779C8.82684 17.0975 8.74157 15.5358 9.01389 14.0167C9.2862 12.4976 9.90862 11.0628 10.8318 9.82608C11.755 8.58933 12.9536 7.58461 14.3325 6.89157C15.7115 6.19852 17.2329 5.8362 18.7762 5.83333ZM18.7762 1.99999C16.6324 1.99744 14.5176 2.49523 12.6 3.45376C10.6824 4.41229 9.01493 5.80511 7.73029 7.52141C6.44566 9.23772 5.57929 11.2301 5.20011 13.3402C4.82094 15.4502 4.93941 17.6196 5.54612 19.6758C6.15283 21.7319 7.23102 23.6182 8.69492 25.1844C10.1588 26.7506 11.968 27.9535 13.9786 28.6975C15.9892 29.4415 18.1457 29.706 20.2764 29.47C22.4072 29.234 24.4536 28.504 26.2526 27.3381C26.8824 26.928 27.3778 26.3418 27.6772 25.6524C27.9766 24.963 28.0667 24.2009 27.9363 23.4607C27.8059 22.7205 27.4609 22.035 26.944 21.4893C26.4271 20.9437 25.7612 20.562 25.0292 20.3918C24.0004 20.134 23.0873 19.5399 22.4349 18.7037C21.7825 17.8676 21.4281 16.8374 21.4281 15.7769C21.4281 14.7163 21.7825 13.6862 22.4349 12.8501C23.0873 12.0139 24.0004 11.4198 25.0292 11.1619C25.7612 10.9917 26.4271 10.6101 26.944 10.0645C27.4609 9.51882 27.8059 8.83329 27.9363 8.0931C28.0667 7.35292 27.9766 6.59074 27.6772 5.90135C27.3778 5.21196 26.8824 4.62579 26.2526 4.21572C24.0267 2.77078 21.43 2.00123 18.7762 1.99999Z"
            fill={color}
          />
        </G>
        {isWeb ? (
          <Defs>
            <ClipPath id="clip_calendar">
              <Rect
                width="23"
                height="27.547"
                fill="white"
                transform="translate(5 2)"
              />
            </ClipPath>
          </Defs>
        ) : null}
      </Svg>
    </TouchableOpacity>
  );
}
